import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clientsApi, Client } from '../api/clientsApi';
import { PaginatedResponse } from '@/shared/types/api';
import { queryKeys, invalidateEntityQueries } from '@/shared/lib/react-query';

// Deprecated: используйте queryKeys.clients вместо этого
export const CLIENTS_QUERY_KEY = ['clients'];
export const CLIENTS_PER_PAGE = 10;

export interface ClientsFilters {
  country?: string;
  verification_status?: 'new' | 'verified' | 'verification_needed';
  registration_start_date?: string;
  registration_end_date?: string;
  sort?: {
    registration_date: 'asc' | 'desc';
  };
}

type ClientsResponse = PaginatedResponse<Client>;

export function useClients(page: number = 1, filters?: ClientsFilters) {
  return useQuery<ClientsResponse>({
    queryKey: queryKeys.clients.list(page, filters),
    queryFn: async () => {
      return clientsApi.getClients({
        offset: (page - 1) * CLIENTS_PER_PAGE,
        limit: CLIENTS_PER_PAGE,
        filters: {
          country: filters?.country,
          verification_status: filters?.verification_status,
          registration_start_date: filters?.registration_start_date,
          registration_end_date: filters?.registration_end_date
        },
        sort: filters?.sort
      });
    }
  });
}

/**
 * Получить клиента по ID
 * @param id - ID клиента
 */
export function useClient(id: string) {
  return useQuery({
    queryKey: queryKeys.clients.detail(id),
    queryFn: () => clientsApi.getClientById(id)
  });
}

/**
 * @deprecated Используйте useClient вместо этого
 */
export function useClientById(id: string) {
  return useClient(id);
}

export function useBlockClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: clientsApi.blockClient,
    onSuccess: () => {
      invalidateEntityQueries.clients(queryClient);
    }
  });
}

export function useUnblockClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: clientsApi.unblockClient,
    onSuccess: () => {
      invalidateEntityQueries.clients(queryClient);
    }
  });
}
